<footer>
    <span class="left">
        &copy; 2022 YaMa: <small>Yet Another Messaging App</small>
    </span>
    <span class="right">
        <a href="#/about">About Us</a>
    </span>
</footer>

<style lang="scss">
    footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 1.25em;
        overflow: hidden;
        white-space: nowrap;
        font-size: 0.75em;
        padding: 0.5em 0;
    }

    .left {
        display:inline-block;
        width: 50%;
        text-align: left;
        padding-left: 16px;
    }
    .right {
        display:inline-block;
        width: 50%;
        text-align: right;
    }
    .right>a {
        padding-right: 32px;
    }
</style>
